/** Runtime configuration from Vite env variables. See `.env.example`. */
export type ApiMode = 'mock' | 'live';

export interface AppConfig {
  apiMode: ApiMode;
  apiUrl: string;
  cognitoDomain: string;
  cognitoClientId: string;
  redirectUri: string;
  logoutUri: string;
}

function origin(): string {
  return typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
}

export function readConfig(env: Record<string, string | boolean | undefined> = import.meta.env): AppConfig {
  const str = (k: string) => {
    const v = env[k];
    return typeof v === 'string' ? v.trim() : '';
  };
  const mode = str('VITE_API_MODE');
  const apiMode: ApiMode = mode === 'mock' || mode === 'live' ? mode : env.DEV ? 'mock' : 'live';
  return {
    apiMode,
    apiUrl: str('VITE_API_URL').replace(/\/+$/, ''),
    cognitoDomain: str('VITE_COGNITO_DOMAIN').replace(/\/+$/, ''),
    cognitoClientId: str('VITE_COGNITO_CLIENT_ID'),
    redirectUri: str('VITE_REDIRECT_URI') || `${origin()}/auth/callback`,
    logoutUri: str('VITE_LOGOUT_URI') || `${origin()}/`,
  };
}

export const config: AppConfig = readConfig();
